export const criteo = (partnersIds) => {
  window.criteo_q = window.criteo_q || []
  const deviceType = /iPad/.test(navigator.userAgent)
    ? 't'
    : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)
    ? 'm'
    : 'd'

  Object.entries(partnersIds).forEach(([partnerId, partnerOptions]) => {
    if ('events' in partnerOptions) {
      callEvents(partnerId, partnerOptions.events)
    }
  })

  function callEvents(partnerId, tracks) {
    Object.entries(tracks).forEach(([index, track]) => {
      const eventFormated = {
        event: 'viewBasket',
        item: [track.params.product],
      }

      if (track.type == 'purchase') {
        eventFormated.event = 'trackTransaction'
        eventFormated.id = track.params.order_id
      }

      window.criteo_q.push(
        {event: 'setAccount', account: partnerId},
        {event: 'setEmail', email: track.params.customer_email},
        {event: 'setSiteType', type: deviceType},
        eventFormated
      )
    })
  }
}
